module.exports = __webpack_public_path__ + "media/images/message_photo-2a23ce32b67c0a30176e29872205378b.png";